export async function AccesoCreate( 
    accUser,
    metaFecha ) {
    const formData = {
        status: "publish",
        meta: {
            accUser: accUser,
            metaFecha: metaFecha
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/acceso', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }
}


export async function AccesoSchedule(
    accUser,
    metaFecha,
    scheduledDate
) {
    const formData = {
        status: "future",
        date: scheduledDate,
        meta: {
            accUser: accUser,
            metaFecha: metaFecha,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/acceso', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }
}
